import { Inject, Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

import { COUNTRIES_API } from './countries.token';
import { CountriesApi } from './countries.api.interface';
import { AuthFacade, AUTH_SERVICE_TOKEN } from '@coin-depo-core/auth';
import { StorageService } from '@coin-depo-core/storage';

import type { Country } from '@coin-depo-types';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private countries$ = new BehaviorSubject<Country[]>(
    this.storage.get('countries', [])
  );
  private allCountries$ = new BehaviorSubject<Country[]>(
    this.storage.get('allCountries', [])
  );

  cachedCountries$ = this.countries$.asObservable();
  cachedAllCountries$ = this.allCountries$.asObservable();

  constructor(
    private storage: StorageService,
    @Inject(COUNTRIES_API) private apiService: CountriesApi,
    @Inject(AUTH_SERVICE_TOKEN) private authService: AuthFacade,
  ) {}

  getCountriesSnapshot() {
    return this.countries$.value;
  }

  getAllCountriesSnapshot() {
    // @ts-ignore
    return this.cachedAllCountries$.value || [];
  }

  updateCountries() {
    return this.apiService
      .getCountries({
        username: this.authService.userData.username!,
        client_token: this.authService.accessToken,
      })
      .pipe(
        tap((res) => {
          this.countries$.next(res.countries_list);
          this.storage.set('countries', res.countries_list);
        })
      );
  }

  updateAllCountries() {
    return this.apiService
      .getAllCountries({
        username: this.authService.userData.username!,
        client_token: this.authService.accessToken,
      })
      .pipe(
        tap((res) => {
          this.allCountries$.next(res.countries_list);
          this.storage.set('allCountries', res.countries_list);
        })
      );
  }

  getSupportedDocuments(country_code: string) {
    return this.apiService
      .getSupportedDocuments({
        username: this.authService.userData.username!,
        client_token: this.authService.accessToken,
        country_code,
      })
      .pipe(map((res) => res.supported_documents));
  }
}
